import type { Writable } from 'svelte/store';

import { createStorableWritable } from '@shared/libs/tools';
import type { LayoutType } from '@shared/types';

const layoutTypeInitial: LayoutType = 'relative';
const layoutTypeMobileInitial: LayoutType = 'single';

export const layoutType: Writable<LayoutType> = createStorableWritable('layouttype', layoutTypeInitial);
export const layoutTypeMobile: Writable<LayoutType> = createStorableWritable('layouttypemob', layoutTypeMobileInitial);
